var defaultProps = {
  rows: [],
  cols: [],
  className: '',
  direction: 'row',
  justify: 'flex-start',
  gutter: 0,
  wrap: 'wrap'
};

export { defaultProps };
//# sourceMappingURL=defaultProps.js.map
